let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ckqbP")).then(() => parcelRequire('bhz32'));